import { NgModule, APP_INITIALIZER} from '@angular/core';
import { AppSettingsService } from './app-settings.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

//Load the AppSettings as soon the application initializes
export function initLoadAppSettings(appConfigService: AppSettingsService) {
  return () => appConfigService.loadAppSettings();
}

@NgModule({ imports: [], providers: [
        AppSettingsService,
        { provide: APP_INITIALIZER, useFactory: initLoadAppSettings, deps: [AppSettingsService], multi: true },
        provideHttpClient(withInterceptorsFromDi())
    ] })

export class AppSettingsModule { }
